import EditableContentHeader from './EditableContentHeader';

/**
 * EditableDetailPage - Wrapper for editable detail pages with consistent structure
 * Provides the header, spacing, and container for detail content
 */
export default function EditableDetailPage({
  title,
  subtitle,
  isEditMode,
  onEdit,
  onSave,
  onCancel,
  isSaving,
  children
}) {
  return (
    <div className="p-8 max-w-5xl">
      <EditableContentHeader
        title={title}
        subtitle={subtitle}
        isEditMode={isEditMode}
        onEdit={onEdit}
        onSave={onSave}
        onCancel={onCancel}
        isSaving={isSaving}
      />

      <div className="space-y-8">
        {children}
      </div>
    </div>
  );
}
